import { render, staticRenderFns } from "./ConfigResumeHeader.vue?vue&type=template&id=2a859f7d&scoped=true"
import script from "./ConfigResumeHeader.vue?vue&type=script&lang=js"
export * from "./ConfigResumeHeader.vue?vue&type=script&lang=js"
import style0 from "./ConfigResumeHeader.vue?vue&type=style&index=0&id=2a859f7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a859f7d",
  null
  
)

export default component.exports